import React, { useEffect, useState } from 'react';
import { Trophy, Activity } from 'lucide-react';
import Ranking from './Ranking';
import { getRanking } from '../utils/supabase';

const Lobby = ({ onGoToSetup, onGoToExam, onShowProgress }) => {
  const [rankingUsers, setRankingUsers] = useState([]);
  const [isLoadingRanking, setIsLoadingRanking] = useState(false);

  const loadRanking = async () => {
    setIsLoadingRanking(true);
    try {
      const { data } = await getRanking(10);
      setRankingUsers(data || []);
    } catch (err) {
      console.error('Error cargando ranking:', err);
    } finally {
      setIsLoadingRanking(false);
    }
  };

  useEffect(() => {
    loadRanking();
    // Recargar ranking cada vez que se vuelve al lobby
  }, []);

  // No perfil aquí: el progreso completo se ve en el modal

  return (
    <div className="min-h-screen py-4 px-3 sm:py-6 sm:px-4">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-6 sm:mb-8">
          <div className="flex items-center justify-center gap-3 mb-3">
            <div className="p-3 sm:p-4 bg-white/90 rounded-3xl shadow-xl">
              <Trophy className="w-10 h-10 sm:w-12 sm:h-12 text-purple-400" />
            </div>
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-700">Lobby</h2>
          </div>
          <p className="text-base sm:text-lg text-gray-600 font-medium">
            Revisa el ranking y tu perfil
          </p>
        </div>

        {/* Action Buttons (solo visibles en pantallas medianas en adelante) */}
        <div className="hidden md:flex flex-col md:flex-row gap-3 md:gap-4 justify-center mb-6 md:mb-8">
          <button
            onClick={onGoToSetup}
            className="flex items-center justify-center gap-2 px-6 sm:px-8 py-3 sm:py-4 bg-gradient-to-r from-purple-500 via-pink-500 to-purple-500 hover:from-purple-600 hover:via-pink-600 hover:to-purple-600 text-white rounded-xl sm:rounded-2xl font-bold text-base sm:text-lg shadow-xl hover:shadow-xl transition-all transform hover:scale-105 active:scale-95 border-2 border-white/30"
          >
            <Trophy className="w-5 h-5 sm:w-6 sm:h-6" />
            Quiz
          </button>

          <button
            onClick={onGoToExam}
            className="flex items-center justify-center gap-2 px-6 sm:px-8 py-3 sm:py-4 bg-gradient-to-r from-indigo-500 via-blue-500 to-indigo-500 hover:from-indigo-600 hover:via-blue-600 hover:to-indigo-600 text-white rounded-xl sm:rounded-2xl font-bold text-base sm:text-lg shadow-xl hover:shadow-xl transition-all transform hover:scale-105 active:scale-95 border-2 border-white/30"
          >
            <Activity className="w-5 h-5 sm:w-6 sm:h-6" />
            Examen
          </button>

          {onShowProgress && (
            <button
              onClick={onShowProgress}
              className="flex items-center justify-center gap-2 px-6 sm:px-8 py-3 sm:py-4 bg-gradient-to-br from-emerald-500 to-green-500 hover:from-emerald-600 hover:to-green-600 text-white rounded-xl sm:rounded-2xl font-bold text-base sm:text-lg shadow-xl hover:shadow-xl transition-all transform hover:scale-105 active:scale-95"
            >
              <Activity className="w-5 h-5 sm:w-6 sm:h-6" />
              Progreso
            </button>
          )}
        </div>
        

        {/* Ranking */}
        <div className="bg-white/90 backdrop-blur-sm rounded-3xl shadow-2xl p-4 sm:p-6 md:p-8 border border-purple-100">
          {isLoadingRanking ? (
            <div className="flex items-center justify-center py-12">
              <div className="animate-spin rounded-full h-12 w-12 border-4 border-purple-500 border-t-transparent"></div>
            </div>
          ) : (
            <Ranking users={rankingUsers} />
          )}
        </div>
      </div>
    </div>
  );
};

export default Lobby;
